import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

function updateGoogleConsent(granted) {
  if (typeof window.gtag === 'function') {
    const value = granted ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      'ad_storage': value,
      'ad_user_data': value,
      'ad_personalization': value,
      'analytics_storage': value
    });
  }
}

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    updateGoogleConsent(true);
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    updateGoogleConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          We use cookies and analytics to improve your experience and measure site performance.
          You can accept or decline tracking.{' '}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
        <div className="cookie-buttons">
          <button className="cookie-btn-accept" onClick={handleAccept}>Accept</button>
          <button className="cookie-btn-decline" onClick={handleDecline}>Decline</button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
